import { signal } from '@angular/core';

/**
 * Create a signal that resets its value after the given delay.
 * @param value Initial value of the signal.
 * @param delay Duration in ms after which the value should be reset.
 */
export function useResettingSignal<T>(value: T, delay: number) {
  const valueRef = signal(value);
  const originalSet = valueRef.set;
  let timeoutId: number | undefined = undefined;

  valueRef.set = (updatedValue) => {
    originalSet(updatedValue);

    if (timeoutId != null) {
      window.clearTimeout(timeoutId);
    }

    timeoutId = window.setTimeout(() => {
      originalSet(value);
      timeoutId = undefined;
    }, delay);
  };

  return valueRef;
}
